import React from 'react';
import AppSettingsContext from '../context.js';
import * as u from '../utils.js'

import Truncate from 'react-truncate';
import chroma from 'chroma-js';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs-ext/plugin/customParseFormat.js';
import {Scrollbars} from 'react-custom-scrollbars';

dayjs.extend(customParseFormat);
/*---------------------------------------------*/

class Element extends React.Component {
	static contextType = AppSettingsContext;

	constructor() {
		super();

		this.container = React.createRef();
		this.broadcast = this.broadcast.bind(this);

		this.state = {
			hover: false
		}
		
		this.toggleHover = this.toggleHover.bind(this);
		this.hoverEvents = {
			onMouseEnter: this.toggleHover,
			onMouseLeave: this.toggleHover
		}
	}

	toggleHover() {
		this.setState({hover: !this.state.hover});
	}

	// shouldComponentUpdate(nextProps, nextState) {
	// 	return true;
	// }

	componentDidUpdate(prevProps) {
		// this.broadcast('content-changed');
	}

	broadcast(message) {
		if (!this.container.current) {
			console.log("Failed to broadcast - no container");
			return;
		}

		u.dispatchEvent(this.container.current,message);
	}
}

/*---------------------------------------------*/

class NameElement extends Element {
	render() {
		let style = {
			...this.props.baseStyle,
			...u.getFontStyle(this.context,'style.name.font'),
			color: u.renderColor(this.context.get('style.name.color'))
		};

		return (
			<div className="name" style={style} ref={this.container}>{this.props.name}</div>
		)
	}
}

/*---------------------------------------------*/

class JobTitleElement extends Element {
	render() {
		let enabled = this.context.get('fields.job_title.enabled');
		if (enabled === false)
			return null;

		let style = {
			...this.props.baseStyle,
			...u.getFontStyle(this.context,'style.job_title.font'),
			color: u.renderColor(this.context.get('style.job_title.color'))
		}

		return (
			<div className="job_title" style={style} ref={this.container}>{this.props.title}</div>
		)
	}
}

/*---------------------------------------------*/

class DateElement extends Element {
	constructor(props) {
		super(props);
		this.cache = {};
	}

	render() {
		let enabled = this.context.get('fields.date.enabled');
		if (enabled === false)
			return null;

		let styles = {
			container: {
				...this.props.baseStyle,
				...u.getFontStyle(this.context,'style.date.font'),
				color: u.renderColor(this.context.get('style.date.color'))
			},
			link: {
				color: 'inherit',
				textDecoration: 'none'
			}
		}

		let dateFormat = this.context.get('fields.date.format') || 'DD MMM YYYY';
		let cacheKey = this.props.date + dateFormat;

		let dateFormatted = this.cache[cacheKey];
		if (!dateFormatted) {
			let date = dayjs(this.props.date);
			if (!date.isValid()) {
				date = dayjs(this.props.date,"DD/MM/YYYY");
			}

			if (!date.isValid()) {
				return null;
			}

			dateFormatted = date.format(dateFormat);
		}

		let content = dateFormatted;
		if (this.props.link) {
			content = <a href={this.props.link} style={styles.link} target="_blank" rel="noopener noreferrer">{content}</a>;
		}

		this.cache[cacheKey] = dateFormatted;
		return (
			<div className="date" ref={this.container} style={styles.container}>{content}</div>
		)
	}
}

/*---------------------------------------------*/

class CompanyElement extends Element {
	render() {
		let enabled = this.context.get('fields.company.enabled');
		if (enabled === false)
			return null;

		let link_url = this.props.url;
		let link_text = this.props.text;
		if (!link_url && !link_text)
			return null;

		let style = {
			textDecoration: 'none', // default decoration
			...this.props.baseStyle,
			...u.getFontStyle(this.context,'style.job_title.font'),
			color: u.renderColor(this.context.get('style.job_title.color')) || 'inherit',
			fontWeight: 'bold', // override
			overflow: 'hidden',
			verticalAlign: 'top', // if display is set to inline-block an additional space will be added below the element which is solved by vertical-align:top/bottom
			textOverflow: 'ellipsis'
		};

		if (link_url) 
			style.cursor = 'pointer';

		link_text = link_text || link_url.replace(/^https?:\/\//i,"");
		return (
			<a href={link_url} className="link" style={style} target="_blank" rel="noopener noreferrer" ref={this.container}>{link_text}</a>
		)
	}
}

/*---------------------------------------------*/

const RADIUS_PRESETS = {
	circle: 100,
	rounded: 8,
	square: 0
}

class ImageElement extends Element {
	render() {
		let enabled = this.props.enabled || this.context.get('fields.image.enabled');
		if (enabled === false)
			return null;

		let size = this.props.size || 64;
		let radius = ('radius' in this.props) ? this.props.radius : this.context.get('style.image.radius',"circle");
		radius = radius in RADIUS_PRESETS ? RADIUS_PRESETS[radius] : radius;

		let imageUrl = this.props.image || 'https://plugin.getpraise.com/v2/settings/img/user.svg';
		if (imageUrl === '/v2/common/img/user.svg')
			imageUrl = 'https://plugin.getpraise.com/v2/settings/img/user.svg';
		
		let styles = {
			container: {
				...this.props.baseStyle,
				fontSize: 0,
				display: 'inline-block'
			},
			image: {
				height: size,
				width: size,
				//transition: 'width .05s, height .05s', /* this is for thumbnails layout. need to move? */
				overflow: 'hidden',
				borderRadius: radius,
				background: 'no-repeat center center',
				backgroundColor: 'white',
				backgroundClip: 'content-box',
				backgroundSize: 'cover', // 'contain' leaves white space if the image is not square
				backgroundImage: 'url('+imageUrl+')'
			}
		};
		
		if (!this.props.noborder) {
			let borderWidth = this.context.get('style.image.border.width',0);
			let borderColor = u.renderColor(this.context.get('style.image.border.color'));
			
			styles.image.border = `${borderWidth}px solid ${borderColor}`;
		}

		return (
			<div className="image" style={styles.container} align-top={this.props.alignTop}>
				<div style={styles.image} alt="" ref={this.container}></div>
			</div>
		)
	}
}

/*---------------------------------------------*/

class StarElement extends Element {
	render() {
		let size = this.props.size || 16;
		let color = this.props.color || 'black';
		let value = this.props.value;
		let position = {0: 'left', 4: 'right'}[this.props.index] || 'center';
		let style = {}

		if (this.props.type === 'opacity') {
			style.opacity = (this.props.value ? 1 : 0.5);
			value = true;
		}

		let viewBox = {
			center: '0 0 16 16',
			left: '0 0 15 16',
			right: '0 0 15 16',
		}

		let svgPath = {
			center: {
				true:  <path fill={color} fillRule="nonzero" d="M8 11.513L12.12 14l-1.093-4.687 3.64-3.153-4.794-.407L8 1.333l-1.873 4.42-4.794.407 3.64 3.153L3.88 14z"/>,
				false: <path fill={color} fillRule="nonzero" d="M7.99666667,1.33333333 L9.87,5.75333333 L14.6633333,6.16 L11.0233333,9.31333333 L12.1166667,14 L7.99666667,11.5133333 L3.87666667,14 L4.97,9.31333333 L1.33,6.16 L6.12333333,5.75333333 L7.99666667,1.33333333 Z M9.18459912,6.69877635 L7.996,3.896 L6.80873422,6.69877635 L3.775,6.956 L6.08097724,8.95271765 L5.388,11.919 L7.99666667,10.3453074 L10.604,11.919 L9.91235609,8.95271765 L12.217,6.956 L9.18459912,6.69877635 Z" />
			},
			left: {
				true:  <path fill={color} fillRule="nonzero" d="M7 11.513L11.12 14l-1.093-4.687 3.64-3.153-4.794-.407L7 1.333l-1.873 4.42-4.794.407 3.64 3.153L2.88 14z"/>,
				false: <path fill={color} fillRule="nonzero" d="M7,1.33333333 L8.87333333,5.75333333 L13.6666667,6.16 L10.0266667,9.31333333 L11.12,14 L7,11.5133333 L2.88,14 L3.97333333,9.31333333 L0.333333333,6.16 L5.12666667,5.75333333 L7,1.33333333 Z M8.18793245,6.69877635 L7,3.895 L5.81206755,6.69877635 L2.779,6.955 L5.08431057,8.95271765 L4.392,11.919 L7,10.3453074 L9.607,11.919 L8.91568943,8.95271765 L11.22,6.955 L8.18793245,6.69877635 Z" />
			},
			right: {
				true:  <path fill={color} fillRule="nonzero" d="M8 11.513L12.12 14l-1.093-4.687 3.64-3.153-4.794-.407L8 1.333l-1.873 4.42-4.794.407 3.64 3.153L3.88 14z"/>,
				false: <path fill={color} fillRule="nonzero" d="M7.99666667,1.33333333 L9.87,5.75333333 L14.6633333,6.16 L11.0233333,9.31333333 L12.1166667,14 L7.99666667,11.5133333 L3.87666667,14 L4.97,9.31333333 L1.33,6.16 L6.12333333,5.75333333 L7.99666667,1.33333333 Z M9.18459912,6.69877635 L7.996,3.896 L6.80873422,6.69877635 L3.775,6.956 L6.08097724,8.95271765 L5.388,11.919 L7.99666667,10.3453074 L10.604,11.919 L9.91235609,8.95271765 L12.217,6.956 L9.18459912,6.69877635 Z" />
			}
		}

		return (
			<svg style={style} xmlns="http://www.w3.org/2000/svg" height={size} viewBox={viewBox[position]}>
				<g fill="none" fillRule="evenodd">
					<path key="1" d="M0 0h16v16H0z"/>
					{svgPath[position][value]}
				</g>
			</svg>
		)
	}
}

class RatingElement extends Element {
	render() {
		let enabled = this.context.get('fields.rating.enabled');
		if (enabled === false)
			return null;

		let value = this.props.rating;
		if (!value) {
			// return "##NO RATING##";
			return null;
		}

		let style = {
			...this.props.baseStyle,
			whiteSpace: 'nowrap',
			fontSize: 0
		}

		let iconSize = this.context.get('fields.rating.fontSize',16); // TODO: remove default
		let color = u.renderColor(this.context.get('style.rating.color'));
		let stars = Array(5).fill(null).map((v,i) => <StarElement size={iconSize} color={color} key={i} index={i} value={i < value} />);
		
		return (
			<div className="rating" style={style} ref={this.container} align-top={this.props.alignTop}>{stars}</div>
		)
	}
}

/*---------------------------------------------*/

class IconElement extends Element {
	render() {
		let enabled = this.context.get('fields.icons.enabled',true);
		if (enabled === false)
			return null;

		let size = this.context.get('style.date.font.size','16').toString().replace('px','');
		let color = null;
		if (this.context.get('style.icon.customColor'))
			color = u.renderColor(this.context.get('style.icon.color'))
		
		let styles = {
			container: {
				...this.props.baseStyle,
				...u.getFontStyle(this.context,'style.date.font'),
				marginLeft: size/4,
				marginRight: size/4
			},
			link: {
				textDecoration: 'none'
			},
			icon: {
				width: size,
				verticalAlign: 'middle'
			}
		}

		let icon = (() => {
			switch (this.props.type) {
				case 'twitter':
					return (
						<g fill="none" fillRule="evenodd">
							<path key="1" d="M0 0h16v16H0z"/>
							<path key="2" fill={color || '#1DA1F2'} fillRule="nonzero" d="M5.508 13c5.073 0 7.848-4.232 7.848-7.903 0-.12 0-.24-.008-.359a5.634 5.634 0 0 0 1.376-1.437 5.476 5.476 0 0 1-1.584.437A2.784 2.784 0 0 0 14.353 2.2a5.505 5.505 0 0 1-1.752.675 2.747 2.747 0 0 0-3.314-.547 2.787 2.787 0 0 0-1.386 3.08 7.813 7.813 0 0 1-5.685-2.902 2.791 2.791 0 0 0 .854 3.707 2.723 2.723 0 0 1-1.252-.347v.035c0 1.322.926 2.46 2.213 2.723a2.736 2.736 0 0 1-1.246.047 2.764 2.764 0 0 0 2.577 1.93 5.51 5.51 0 0 1-4.082 1.15 7.77 7.77 0 0 0 4.228 1.246"/>
						</g>
					)

				case 'yelp':
					return (
						<g fill="none">
							<path key="1" d="M0 0h16v16H0z"/>
							<path key="2" fill={color || '#D32323'} d="M2.42 7.116l2.539 1.236a.581.581 0 0 1-.115 1.087l-2.741.682a.583.583 0 0 1-.72-.5 4.997 4.997 0 0 1 .229-2.17.582.582 0 0 1 .807-.335M3.436 12.335l1.89-2.096a.582.582 0 0 1 1.015.41l-.1 2.82a.582.582 0 0 1-.678.553 5.063 5.063 0 0 1-2.025-.818.581.581 0 0 1-.102-.869M7.918 9.546l2.686.872a.581.581 0 0 1 .346.803 5.052 5.052 0 0 1-1.343 1.719.584.584 0 0 1-.865-.14l-1.498-2.393a.581.581 0 0 1 .674-.861M10.65 7.834l-2.716.778a.581.581 0 0 1-.643-.884l1.58-2.339a.583.583 0 0 1 .867-.112 5.005 5.005 0 0 1 1.285 1.765.582.582 0 0 1-.373.792M4.304 1.254c-.49.131-.956.304-1.396.514a.58.58 0 0 0-.252.815l2.654 4.59c.298.515 1.086.304 1.086-.29V1.582a.582.582 0 0 0-.626-.58 8.14 8.14 0 0 0-1.466.252"/>
						</g>
					)
				
				case 'facebook':
					return (
						<g fill="none" fillRule="evenodd">
							<path key="1" d="M0 0h16v16H0z"/>
							<path key="2" fill={color || '#1877F2'} d="M15 7.043C15 3.153 11.866 0 8 0S1 3.153 1 7.043C1 10.558 3.56 13.472 6.906 14V9.079H5.13V7.043h1.777V5.49c0-1.765 1.045-2.74 2.644-2.74.766 0 1.567.138 1.567.138v1.733h-.882c-.87 0-1.141.543-1.141 1.1v1.32h1.941l-.31 2.037H9.094V14C12.44 13.472 15 10.558 15 7.043"/>
						</g>
					)
				
				case 'gmb':
				case 'google':
				case 'google-maps':
					return (
						<g fill="none" fillRule="evenodd">
							<path key="1" d="M0 0h16v16H0z"/>
							<path key="2" fill={color || '#4285F4'} d="M14.24 7.648c0-.461-.041-.904-.118-1.33H8v2.514h3.498a2.99 2.99 0 0 1-1.297 1.962v1.631h2.1c1.23-1.131 1.939-2.798 1.939-4.777z"/>
							<path key="3" fill={color || '#34A853'} d="M8 14c1.755 0 3.226-.582 4.302-1.575l-2.1-1.63c-.583.39-1.327.62-2.202.62-1.693 0-3.126-1.144-3.637-2.68H2.191v1.684A6.498 6.498 0 0 0 8 14z"/>
							<path key="4" fill={color || '#FBBC05'} d="M4.363 8.735A3.907 3.907 0 0 1 4.159 7.5c0-.428.074-.845.204-1.235V4.581H2.191a6.497 6.497 0 0 0 0 5.838l2.172-1.684z"/>
							<path key="5" fill={color || '#EA4335'} d="M8 3.585c.954 0 1.811.328 2.485.972l1.864-1.864C11.223 1.644 9.752 1 8 1a6.498 6.498 0 0 0-5.809 3.58l2.172 1.685C4.874 4.729 6.307 3.585 8 3.585z"/>
						</g>
					)
				
				default:
					return null;
			}
		})();

		if (!icon)
			return null;

		let content = (
			<svg style={styles.icon} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
				{icon}
			</svg>
		)

		if (this.props.link) {
			content = <a href={this.props.link} style={styles.link} target="_blank" rel="noopener noreferrer">{content}</a>;
		}

		return (
			<div style={styles.container}>
				{content}
			</div>
		)
	}
}

/*---------------------------------------------*/

/*class Truncate2 extends Element {
	constructor() {
		super();

		this.container = React.createRef();
		this.state = {
			count: 1,
			ready: false
		};
	}

	render() {
		let lineHeight = 1*this.context.get('lineHeight',1.75,1.5);

		let styles = {
			container: {
				overflow: 'hidden',
				// visibility: this.state.ready ? 'visible' : 'hidden',
				height: this.props.lines*lineHeight+'em'
			},
			spacer: {
				height: (this.props.lines-1)*lineHeight+'em',
				float: 'right'
			},
			button: {
				float: 'right',
				clear: 'right'
			}
		}

		let content = this.props.children;
		// let chunks = content.split(' ');
		// if (chunks.length > this.state.count) {
		// 	content = chunks.slice(0,this.state.count).join(' ');
		// 	setTimeout(() => {
		// 		console.log(this.container.current.scrollHeight,this.container.current.offsetHeight,this.state.count)
		// 		if (this.container.current && (this.container.current.scrollHeight <= this.container.current.offsetHeight)) {
		// 			this.setState({count: this.state.count+10});
				
		// 		} else {
		// 			this.setState({ready: true});
		// 		}
		// 	});
		// }

		return (
			<div style={styles.container} ref={this.container} count={this.state.count}>
				<div style={styles.spacer}></div>
				<button style={styles.button}>READ MORE</button>
				{content}
			</div>
		)
	}
}*/

class TruncatedElement extends Element {
	constructor() {
		super();
		this.state = {
			...this.state,
			expanded: false,
			truncated: false,
			height: 0
		};

		this.container = React.createRef();
		this.truncateRef = React.createRef();

		this.onExpand = this.onExpand.bind(this);
		this.onCollapse = this.onCollapse.bind(this);
		this.onTruncate = this.onTruncate.bind(this);
	}

	onExpand() {
		this.setState({expanded: true});
		window.ga && window.ga('send','event','text','limit','read-more');
	}

	onCollapse() {
		this.setState({expanded: false});
		window.ga && window.ga('send','event','text','limit','read-less');
		
	}

	onTruncate(truncated) {
		if (this.state.truncated === truncated)
			return;

		this.setState({truncated: truncated});
		setTimeout(() => this.broadcast('content-changed'));
	}

	// TODO: update on height change
	render() {
		let truncateLines = this.props.maxLines;
		let maxTextLines = this.state.expanded ? 0 : truncateLines;

		// force max height to prevent jittering on loading
		let maxHeight = maxTextLines ? `${this.props.baseStyle.lineHeight*maxTextLines}em` : '';
		
		let style = {
			...this.props.baseStyle,
			overflow: 'hidden',
			maxHeight: maxHeight
		};

		let readMoreLabel = this.context.get('text.limit.labels.readmore') || 'read more';
		let readLessLabel = this.context.get('text.limit.labels.readless') || 'read less';

		let options = {
			lines: maxTextLines,
			width: this.container.current && this.container.current.offsetWidth, // bugfix: text width stuck on 1 column
			ellipsis: <span>... <button style={this.props.buttonStyle} onClick={this.props.onExpand || this.onExpand} href="#">{readMoreLabel}</button></span>
		}

		// setTimeout(() => this.truncateRef && this.truncateRef.current && this.truncateRef.current.onResize());

		return (
			<div className={this.state.expanded ? '' : 'truncated'} style={style} ref={this.container}>
				<Truncate {...options} onTruncate={this.onTruncate} key="content" ref={this.truncateRef}>
					{this.props.text}
				</Truncate>
				{this.state.expanded && [' ',<button style={this.props.buttonStyle} onClick={this.props.onCollapse || this.onCollapse} key="readless">{readLessLabel}</button>]}
			</div>
		)
	}
}

class ContentElement extends Element {
	constructor() {
		super();
		this.state = {
			...this.state,
			height: 0
		};

		// this.checkSize = this.checkSize.bind(this);
	}

	// checkSize() {
	// 	let height = this.container && this.container.current && this.container.current.offsetHeight;
	// 	if (height !== this.state.height)
	// 		this.setState({height: height});
	// }

	render() {
		let displayType = this.props.display || 'line-limit';
		let contentText = this.props.text;
		let content = null;

		let styles = {
			container: {
				...this.props.baseStyle,
				lineHeight: this.props.baseStyle.lineHeight || 1*this.context.get('lineHeight',1.75,1.5) || (!this.context.isMobile() ? 1.75 : 1.5),
				color: u.renderColor(this.context.get('style.text.color'))
			},
			text: {
				...(this.props.font || u.getFontStyle(this.context,'style.text.font')),
			},
			readmore: {
				display: 'inline',
				font: 'inherit',
				backgroundColor: 'transparent',
				color: 'inherit',
				border: 'none',
				padding: 0,
				opacity: 0.4,
				cursor: 'pointer',
				whiteSpace: 'nowrap'
			}
		}
		
		styles.container.overflow = styles.container.overflow || 'visible';
		styles.container.fontSize = styles.container.fontSize || 16;

		let truncateEnabled = this.context.get('text.truncate', false);
		if ((displayType === 'line-limit' && truncateEnabled) || displayType === 'line-fit') {
			let props = {
				text: contentText,
				baseStyle: {...styles.text},
				buttonStyle: styles.readmore,
				height: this.props.height,

				onExpand: this.props.onExpand,
				onCollapse: this.props.onCollapse
			}

			if (truncateEnabled) {
				props.maxLines = this.context.get('text.truncateLines');
			}
			
			if (displayType === 'line-fit') {
				if (this.props.height) {
					let fontSize = (typeof styles.container.fontSize === 'string') ? 1*styles.container.fontSize.replace("px","") : styles.container.fontSize;
					let lineHeight = styles.container.lineHeight * fontSize;
					let maxTextLinesSpace = Math.floor(this.props.height / lineHeight);
					
					props.maxLines = ('maxLines' in props ? Math.min(props.maxLines,maxTextLinesSpace) : maxTextLinesSpace);
				}

				// setTimeout(() => this.truncateRef && this.truncateRef.current && this.truncateRef.current.onResize());
				// setTimeout(() => this.checkSize());
			}
	
			content = <TruncatedElement {...props}>{contentText}</TruncatedElement>

		} else if (displayType === 'scroll') {

			styles.scrollContainer = {
				background: chroma(styles.container.color).alpha(0.2),
				height: '100%',
				width: 8,
				right: 0,
				position: 'absolute',
			}

			styles.scrollThumb = {
				backgroundColor: styles.container.color,
				opacity: 0.6
			}

			content = (
				<Scrollbars style={{...styles.text, height: this.props.height}}
					renderTrackVertical={({style, ...props}) => <div {...props} style={styles.scrollContainer} />}
					renderThumbVertical={({style, ...props}) => <div {...props} style={{...style, ...styles.scrollThumb}} />}
					>

					{contentText}
				</Scrollbars>
			)

		} else {
			content = contentText;
		}

		return (
			<div className="text" style={{...styles.container, ...styles.text}} ref={this.container} align-group={this.props.alignGroup} align-top={this.props.alignTop} >
				{content}
			</div>
		)
	}
}

/*---------------------------------------------*/

class TestimonialBox extends Element {
	render() {
		let style = {
			...this.props.baseStyle,
			background: this.context.get('style.bg.box.color','')
		}

		return (
			<div className="testimonial-box" style={style} ref={this.container}>
				{this.props.children}
			</div>
		)
	}
}

/*---------------------------------------------*/

class Arrow extends Element {
	render() {
		let type = this.props.type;
		if (!type)
			return null;

		const DISABLED_OPACITY = 0.2;

		let size = this.props.size;
		let color = u.renderColor(this.props.color) || 'black';
		let background = u.renderColor(this.props.background);
		let direction = this.props.dir;
		let container = this.props.container;

		/*----------*/

		const ARROWS = {
			'regular': [
				<path key="1" d="M0 0h16v16H0z"/>,
				<path key="2" fill={color} d="M3.202 8.874h11.91A.885.885 0 0 0 16 7.998c0-.481-.4-.875-.889-.875h-11.9l4.514-4.528a.933.933 0 0 0-1.318-1.32L.217 7.473a.744.744 0 0 0 0 1.052l6.19 6.2a.93.93 0 0 0 1.318 0 .931.931 0 0 0 .008-1.313l-4.531-4.54z"/>	 
			],
			'rounded': [
				<path key="1" d="M0 0h16v16H0z"/>,
				<path key="2" fill={color} d="M3.907 8.97l6.39 5.613c.537.484 1.29.584 1.826.1.537-.486.434-1.351.105-1.698L6.513 8.083 12.228 3c.343-.305.416-1.191-.105-1.697-.52-.507-1.34-.311-1.826.1-.325.273-2.455 2.204-6.39 5.793a1.17 1.17 0 0 0 0 1.774z"/>		 
			],
			'rounded-full': [
				<path key="1" d="M0 0h16v16H0z"/>,
				<path key="2" fill={color} d="M10.375 1.3L2.976 7.22a1 1 0 0 0 0 1.56l7.4 5.92A1 1 0 0 0 12 13.92V2.08a1 1 0 0 0-1.625-.78z"/>
			],
			'sharp': [
				<path key="1" d="M0 0h16v16H0z"/>,
				<path key="2" fill={color} d="M9.839 16l1.661-1.2L7.032 8 11.5 1.2 9.839 0 4.5 8z"/>
			],
			'sharp-full': [
				<path key="1" d="M0 0h16v16H0z"/>,
				<path key="2" fill={color} d="M11.5 0l-9 8 9 8z"/>
			]
		}

		/*----------*/
		let styles = {
			container: {
				...this.props.baseStyle,
				width: this.props.width || size*2,
				height: this.props.height || size*2,
				background: background,
				zIndex: 1,
				cursor: 'pointer'
			},
			arrow: {
				position: 'absolute',
				left: '50%',
				top: '50%',
				transform: 'translateX(-50%) translateY(-50%)'
			}
		}

		if (this.props.state === 'disabled') {
			if (this.props.spaced) {
				styles.container.opacity = DISABLED_OPACITY;
			} else {
				styles.container.background = chroma(background).alpha(chroma(background).alpha()*DISABLED_OPACITY);
				styles.arrow.opacity = DISABLED_OPACITY;
			}

		} else if (this.state.hover) {
			styles.container.boxShadow = 'inset 0 100px rgba(0,0,0,0.1)';
		}

		if (direction === 'right')
			styles.arrow.transform += ' scaleX(-1)';

		if (container) {
			let containerType = container.split('-')[0];
			let radius = {square: 0, circle: 100, rounded: '20%'}[containerType];
			styles.container.borderRadius = radius;

			let borderWidth = 1;
			let borderType = this.context.get('layout.slider.arrows.borderType','outside');
			switch (borderType) {
				case 'outside':
					styles.container.border = `${borderWidth}px solid ${color}`;
					styles.container.width -= 2*borderWidth;
					styles.container.height -= 2*borderWidth;
					break;

				case 'inside':
					styles.container.border = `${borderWidth}px solid ${color}`;
					break;

				case 'dropshadow':
					styles.container.boxShadow = `inset 0 0 0 ${borderWidth}px ${color}`;
					break;
				
				default:
					console.log("Invalid borderType",borderType);
					break;		
			}
		}

		let svgPath = ARROWS[type];
		if (!svgPath)
			return null;

		var svg = (
			<svg style={styles.arrow} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
				<g fill="none" fillRule="evenodd">
					{svgPath}
				</g>
			</svg>
		)	
		
		return (
			<div style={styles.container} onClick={this.props.onClick} {...this.hoverEvents}>
				{svg}
			</div>
		)
	}
}

/*---------------------------------------------*/

class BubblePointer extends Element {
	render() {
		let borderColor = this.props.borderColor;
		let borderWidth = this.props.borderWidth;
		let bgColor = this.props.bgColor;
		
		let pointerStyle =  {
			...this.props.baseStyle,
			position: 'absolute',
			width: this.props.size+2,
			height: this.props.size+2,
			overflow: 'hidden',
			zIndex: -1
		};

		let innerPointerStyle = {
			content: '""',
			position: 'absolute',
			left: 'calc(50%)', // half a pixel to fix some visual artifact, not sure whether we indeed need it
			top: `calc(70.7107% - ${borderWidth})`,
			width: '100%',
			height: '100%',
			transform: 'translateX(-50%) rotateZ(-45deg)',
			borderStyle: 'solid',
			borderColor: borderColor,
			borderTopWidth: borderWidth,
			borderRightWidth: borderWidth,
			boxSizing: 'border-box',
			background: bgColor
		};
			
		return (
			<div style={pointerStyle}><div style={innerPointerStyle}></div></div>
		)
	}
}

class Bubble extends Element {
	render() {
		let properties = {
			top: {
				top: 'top',
				bottom: 'bottom',
				left: 'left',
				right: 'right',
				width: 'width',
				height: 'height',
				marginTop: 'marginTop',
				borderTop: 'borderTop',
				borderBottom: 'borderBottom',
				borderRight: 'borderRight',
				borderLeft: 'borderLeft',
				borderTopRightRadius: 'borderTopRightRadius',
				borderBottomRightRadius: 'borderBottomRightRadius',
				borderTopLeftRadius: 'borderTopLeftRadius',
				borderBottomLeftRadius: 'borderBottomLeftRadius',
			},
			bottom: {
				top: 'bottom',
				bottom: 'top',
				left: 'left',
				right: 'right',
				width: 'width',
				height: 'height',
				marginTop: 'marginBottom',
				borderTop: 'borderBottom',
				borderBottom: 'borderTop',
				borderRight: 'borderRight',
				borderLeft: 'borderLeft',
				borderTopRightRadius: 'borderBottomRightRadius',
				borderBottomRightRadius: 'borderTopRightRadius',
				borderTopLeftRadius: 'borderBottomLeftRadius',
				borderBottomLeftRadius: 'borderTopLeftRadius',
			},
			left: {
				top: 'left',
				bottom: 'right',
				left: 'bottom',
				right: 'top',
				width: 'height',
				height: 'width',
				marginTop: 'marginLeft',
				borderTop: 'borderLeft',
				borderBottom: 'borderRight',
				borderRight: 'borderTop',
				borderLeft: 'borderBottom',
				borderTopRightRadius: 'borderTopLeftRadius',
				borderBottomRightRadius: 'borderTopRightRadius',
				borderTopLeftRadius: 'borderBottomLeftRadius',
				borderBottomLeftRadius: 'borderBottomRightRadius',
			},
			right: {
				top: 'right',
				bottom: 'left',
				left: 'top',
				right: 'bottom',
				width: 'height',
				height: 'width',
				marginTop: 'marginRight',
				borderTop: 'borderRight',
				borderBottom: 'borderLeft',
				borderRight: 'borderBottom',
				borderLeft: 'borderTop',
				borderTopRightRadius: 'borderBottomRightRadius',
				borderBottomRightRadius: 'borderBottomLeftRadius',
				borderTopLeftRadius: 'borderTopRightRadius',
				borderBottomLeftRadius: 'borderTopLeftRadius',
			},
		}

		let D = properties[this.props.direction];
		
		let pointerWidth = this.props.pointerSize;
		let pointerHeight = pointerWidth/2;
		let borderRadius = 1*this.context.get('template.bubble.radius',5);
		
		let bgColor = u.renderColor(this.context.get('style.bg.box'));
		
		let borderColor = u.renderColor(this.context.get('style.bubble.border.color','gray'));
		let borderWidth = this.context.get('style.bubble.border.width',1) + 'px';
		let borderStyle = `${borderWidth} solid ${borderColor}`;
		
		
		let styles = {
			bubble: {
				...this.props.baseStyle
			},
			inner: {
				...this.props.baseInnerStyle,
				background: bgColor,
				position: 'relative',
				borderRadius: borderRadius,
				zIndex: 0,
				boxSizing: 'border-box',
				[D.borderBottom]: borderStyle,
				[D.borderTop]: `${borderWidth} solid transparent`, // reserve space for the border, growing the bubble inside
				[D.marginTop]: pointerHeight,
			},
			parts: {
				base: {
					content: '""',
					position: 'absolute',
					boxSizing: 'border-box',
					pointerEvents: 'none',
					[D.top]: `-${borderWidth}`,
					[D.bottom]: `-${borderWidth}`
				}
			}
		}

		styles.parts.left = {
			...styles.parts.base,
			[D.left]: 0,
			[D.width]: `calc(${this.props.pointerOffset} - ${pointerWidth/2}px)`,
			[D.borderLeft]: borderStyle,
			[D.borderTop]: borderStyle,
			// [D.borderBottom]: borderStyle, // this makes the border too strong
			[D.borderTopLeftRadius]: borderRadius,
			[D.borderBottomLeftRadius]: borderRadius
		};

		styles.parts.right = {
			...styles.parts.base,
			[D.right]: 0,
			[D.width]: `calc(100% - ${this.props.pointerOffset} - ${this.props.pointerSize/2}px)`,
			[D.borderRight]: borderStyle,
			[D.borderTop]: borderStyle,
			// [D.borderBottom]: borderStyle,
			[D.borderTopRightRadius]: borderRadius,
			[D.borderBottomRightRadius]: borderRadius
		};

		let pointerStyle = {
			top: {
				top: 0,
				left: this.props.pointerOffset,
				transform: 'translateX(-50%) translateY(-100%)'
			},
			bottom: {
				left: this.props.pointerOffset,
				bottom: 0,
				transform: 'translateX(-50%) translateY(100%) rotateZ(180deg)'
			},
			left: {
				bottom: this.props.pointerOffset,
				left: 0,
				transform: 'translateX(-100%) translateY(50%) rotateZ(-90deg)'
			},
			right: {
				top: this.props.pointerOffset,
				right: 0,
				transform: 'translateX(100%) translateY(-50%) rotateZ(90deg)'
			}
		}[this.props.direction];


		return (
			<div align-top={this.props.alignTop} className="testimonial-bubble" style={styles.bubble} ref={this.props.externalRef || this.container}>
				<div style={styles.inner} align-group={this.props.alignGroup} align-size-bottom={this.props.alignSizeBottom}>
					<div style={styles.parts.left}></div>
					<div style={styles.parts.right}></div>
					<div style={styles.parts.background}></div>

					<BubblePointer size={this.props.pointerSize} bgColor={bgColor} borderColor={borderColor} borderWidth={borderWidth} baseStyle={pointerStyle} />

					{this.props.children}
				</div>
			</div>
		)
	}
}

// https://stackoverflow.com/questions/51526461/how-to-use-react-forwardref-in-a-class-based-component
const BubbleWithRef = React.forwardRef((props, ref) => <Bubble externalRef={ref} {...props} />);

/*---------------------------------------------*/

export {
	Element,
	NameElement,
	JobTitleElement,
	ImageElement,
	StarElement,
	RatingElement,
	DateElement,
	CompanyElement,
	IconElement,
	ContentElement,
	TestimonialBox,
	Arrow,
	Bubble,
	BubbleWithRef
}

/*---------------------------------------------*/
